export class login {
    user: string;
    pass: string;
  }
